module.exports = __webpack_public_path__ + "static/img/logo-gongcha.760b9f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-gongcha.jpg
// module id = LjW8
// module chunks = 83